<template>
  <div class="tooltip">
    <span
      ><b>{{ formatedDate }}</b></span
    >
  </div>
</template>

<script>
import format from "date-fns/format";
import fr from "date-fns/locale/fr";
export default {
  props: {
    date: {
      type: Date,
      required: true
    }
  },
  computed: {
    formatedDate() {
      return format(this.date, "EEEE dd MMMM yyyy", { locale: fr });
    }
  }
};
</script>

<style scoped>
.tooltip {
  position: absolute;
  font-size: 14px;
  left: -100px;
  width: 200px;
  padding: 5px;
  background: #303030;
  border-radius: 5px;
  color: #dfdfdd;
  opacity: 0.9;
}

.tooltip::after {
  content: "";
  height: 10px;
  width: 10px;
  position: absolute;
  background: #303030;
  transform: rotate(45deg);
  left: 100px;
  bottom: -5px;
  z-index: -1;
}
</style>